








































import { computed, defineComponent, toRefs, PropType, ref, watch, nextTick } from '@vue/composition-api';
import { MaterialType } from '@tt4b/ttam-enums';
import { i18n } from '@tt4b/ttam-i18n';
import { trackEvent } from './../../../../utils/index';

const name = 'ttam-library-shop-header';

export default defineComponent({
  name,
  props: {
    libraryType: {
      type: String as PropType<MaterialType>,
      required: true,
    },
    isSupportAffiliate: {
      type: Boolean,
      default: false,
    },
    isSupportVideoLibrary: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    isLoading: { type: Boolean, default: false },
  },

  setup(props, { emit, refs }) {
    const { libraryType, isSupportAffiliate, isSupportVideoLibrary } = toRefs(props);

    const selectedSource = computed({
      get: () => libraryType.value,
      set: val => {
        trackEvent('creative_shop_video_source', { source: val });
        emit('video-source-change', val);
      },
    });
    const videoSourceOptions = computed(() => [
      ...(isSupportAffiliate.value
        ? [
            {
              value: MaterialType.Affiliate,
              label: i18n.t('module_creative_affiliate_video'),
              desc: i18n.t('module_creative_affiliate_video_tips'),
            },
          ]
        : []),
      {
        value: MaterialType.Native,
        label: i18n.t('module_creative_authorized_video'),
        desc: i18n.t('module_creative_authorized_video_tips'),
      },
      ...(isSupportVideoLibrary.value
        ? [
            {
              value: MaterialType.Video,
              label: i18n.t('module_creative_video_library'),
              desc: i18n.t('module_creative_video_library_tips'),
            },
          ]
        : []),
    ]);
    return {
      selectedSource,
      videoSourceOptions,
    };
  },
});
